import { render, staticRenderFns } from "./forgotPassForm.vue?vue&type=template&id=999bcef6&"
import script from "./forgotPassForm.vue?vue&type=script&lang=js&"
export * from "./forgotPassForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports